var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"tencent-player",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.tcPlayerId,"preload":"auto","playsinline":"","webkit-playsinline":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }